import React, { useEffect, useState } from 'react'
import { Divider } from 'primereact/divider';
// import { useGetCAPsessionQuery } from '../coachingActionPlanSlice';
import { FollowUpResultProgress } from '../followUpResultProgress/FollowUpResultProgress';
import { FollowUpResultPerformance } from '../followUpResultPerformance/FollowUpResultPerformance';
import gears from '../../../assets/Gears.png';

interface MyActionPlanViewProps {
    CAPSession: any;
}

export const MyActionPlanView: React.FC<MyActionPlanViewProps> = ({ CAPSession }) => {
    const [CAPSessionData, setCAPSessionData] = useState<any>(null);

    // const { data: CAPSession } = useGetCAPsessionQuery(
    //     { coachingActionPlanId: coachingActionPlanId ?? 0 },
    //     { skip: !coachingActionPlanId }
    // );

    useEffect(() => {
        if (CAPSession?.data && CAPSession.data.length > 0) {
            setCAPSessionData(CAPSession.data[0]);
        }
    }, [CAPSession]);

    return (
        <div className="follow-up-layout__content">
            {CAPSessionData ? (
                <div className="follow-up-layout__results">
                    <FollowUpResultProgress CAPSession={CAPSessionData} metricIndex={1} />
                    <Divider />
                    <FollowUpResultPerformance CAPSession={CAPSessionData} metricIndex={1} />
                    <Divider />
                </div>
            ) : (
                <div className="no-data-wrapper">
                    <div className="no-data-inner">
                        <img src={gears} alt="No Data" className="gears-img" />
                        <div className="no-data-text">
                            No Data
                            <br />
                            Available
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
